/*
 * File: /src/services/airbnbTemplateService.js
 * Created Date: Thursday November 4th 2021
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Sunday, 28th November 2021 11:32:18 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2021 AdBase, Inc.
 */

import { authedAxios } from '../shared/axiosWrapper';
import { S2_AIRBNB_TEMPLATE_PATH } from '../constants';

export default {
  fetchTemplates(params) {
    return authedAxios.get(S2_AIRBNB_TEMPLATE_PATH, { params: params });
  },

  fetchTemplateById(id) {
    return authedAxios.get(S2_AIRBNB_TEMPLATE_PATH + id, {
      params: {
        full: true,
      }
    });
  },

  updateTemplate(id, payload) {
    return authedAxios.put(S2_AIRBNB_TEMPLATE_PATH + id, payload);
  },

  createTemplate(payload) {
    return authedAxios.post(S2_AIRBNB_TEMPLATE_PATH, payload);
  }
};
